export namespace Claims {
  export enum Country {
    Australia = 'AU',
    NewZealand = 'NZ'
  }
  export namespace Country {
    export function toEnum(value: string): Country {
      switch (value.toLocaleUpperCase()) {
        case 'NEW ZEALAND':
        case 'NZ':
          return Country.NewZealand;
        case 'AUSTRALIA':
        case 'AU':
        default:
          return Country.Australia;
      }
    }

    export function toLocale(value: Country): string {
      return value === Country.NewZealand ? 'en-NZ' : 'en-AU';
    }

    export function toCurrencyCode(value: Country): string {
      return value === Country.NewZealand ? 'NZD' : 'AUD';
    }
  }

  export enum UserRoles {
    NetworkAdministrator = 'Network Administrator',
    BusinessAdministrator = 'Business Administrator',
    Principal = 'Principal',
    Adviser = 'Adviser',
    Assistant = 'Assistant'
  }
}
